import { Location } from '../types/location';

export interface County {
  id: string;
  name: string;
}

export interface SubCounty {
  id: string;
  name: string;
  countyName: string;
}

export interface Facility {
  id: string;
  name: string;
  subCountyName: string;
}

// National level
const KENYA_ID = 'KE';

// Real Kenyan Counties
export const counties: County[] = [
  { id: 'C001', name: 'Kilifi' },
  { id: 'C002', name: 'Mombasa' },
  { id: 'C003', name: 'Kwale' },
  { id: 'C004', name: 'Taita Taveta' },
  { id: 'C005', name: 'Lamu' },
  { id: 'C006', name: 'Tana River' },
  { id: 'C007', name: 'Garissa' },
  { id: 'C008', name: 'Wajir' },
  { id: 'C009', name: 'Mandera' },
  { id: 'C010', name: 'Marsabit' },
  { id: 'C011', name: 'Isiolo' },
  { id: 'C012', name: 'Meru' },
  { id: 'C013', name: 'Tharaka-Nithi' },
  { id: 'C014', name: 'Embu' },
  { id: 'C015', name: 'Kitui' },
  { id: 'C016', name: 'Machakos' },
  { id: 'C017', name: 'Makueni' },
  { id: 'C018', name: 'Nyandarua' },
  { id: 'C019', name: 'Nyeri' },
  { id: 'C020', name: 'Kirinyaga' },
  { id: 'C021', name: 'Murang\'a' },
  { id: 'C022', name: 'Kiambu' },
  { id: 'C023', name: 'Turkana' },
  { id: 'C024', name: 'West Pokot' },
  { id: 'C025', name: 'Samburu' },
  { id: 'C026', name: 'Trans Nzoia' },
  { id: 'C027', name: 'Uasin Gishu' },
  { id: 'C028', name: 'Elgeyo-Marakwet' },
  { id: 'C029', name: 'Nandi' },
  { id: 'C030', name: 'Baringo' },
  { id: 'C031', name: 'Laikipia' },
  { id: 'C032', name: 'Nakuru' },
  { id: 'C033', name: 'Narok' },
  { id: 'C034', name: 'Kajiado' },
  { id: 'C035', name: 'Kericho' },
  { id: 'C036', name: 'Bomet' },
  { id: 'C037', name: 'Kakamega' },
  { id: 'C038', name: 'Vihiga' },
  { id: 'C039', name: 'Bungoma' },
  { id: 'C040', name: 'Busia' },
  { id: 'C041', name: 'Siaya' },
  { id: 'C042', name: 'Kisumu' },
  { id: 'C043', name: 'Homa Bay' },
  { id: 'C044', name: 'Migori' },
  { id: 'C045', name: 'Kisii' },
  { id: 'C046', name: 'Nyamira' },
  { id: 'C047', name: 'Nairobi' }
];

// Real Subcounties (focusing on Coast region for demonstration)
export const subCounties: SubCounty[] = [
  { id: 'SC001', name: 'Kilifi North', countyName: 'Kilifi' },
  { id: 'SC002', name: 'Kilifi South', countyName: 'Kilifi' },
  { id: 'SC003', name: 'Malindi', countyName: 'Kilifi' },
  { id: 'SC004', name: 'Magarini', countyName: 'Kilifi' },
  { id: 'SC005', name: 'Ganze', countyName: 'Kilifi' },
  { id: 'SC006', name: 'Kaloleni', countyName: 'Kilifi' },
  { id: 'SC007', name: 'Rabai', countyName: 'Kilifi' },
  { id: 'SC008', name: 'Nyali', countyName: 'Mombasa' },
  { id: 'SC009', name: 'Kisauni', countyName: 'Mombasa' },
  { id: 'SC010', name: 'Mvita', countyName: 'Mombasa' },
  { id: 'SC011', name: 'Likoni', countyName: 'Mombasa' },
  { id: 'SC012', name: 'Changamwe', countyName: 'Mombasa' },
  { id: 'SC013', name: 'Jomvu', countyName: 'Mombasa' },
  { id: 'SC014', name: 'Msambweni', countyName: 'Kwale' },
  { id: 'SC015', name: 'Lunga Lunga', countyName: 'Kwale' },
  { id: 'SC016', name: 'Matuga', countyName: 'Kwale' },
  { id: 'SC017', name: 'Kinango', countyName: 'Kwale' },
  { id: 'SC018', name: 'Voi', countyName: 'Taita Taveta' },
  { id: 'SC019', name: 'Taveta', countyName: 'Taita Taveta' },
  { id: 'SC020', name: 'Wundanyi', countyName: 'Taita Taveta' },
  { id: 'SC021', name: 'Mwatate', countyName: 'Taita Taveta' },
  { id: 'SC022', name: 'Lamu East', countyName: 'Lamu' },
  { id: 'SC023', name: 'Lamu West', countyName: 'Lamu' },
  { id: 'SC024', name: 'Tana Delta', countyName: 'Tana River' },
  { id: 'SC025', name: 'Tana North', countyName: 'Tana River' },
  { id: 'SC026', name: 'Tana River', countyName: 'Tana River' },
  { id: 'SC027', name: 'Garissa Township', countyName: 'Garissa' },
  { id: 'SC028', name: 'Balambala', countyName: 'Garissa' },
  { id: 'SC029', name: 'Lagdera', countyName: 'Garissa' },
  { id: 'SC030', name: 'Dadaab', countyName: 'Garissa' },
  { id: 'SC031', name: 'Fafi', countyName: 'Garissa' },
  { id: 'SC032', name: 'Ijara', countyName: 'Garissa' },
  { id: 'SC033', name: 'Wajir North', countyName: 'Wajir' },
  { id: 'SC034', name: 'Wajir East', countyName: 'Wajir' },
  { id: 'SC035', name: 'Wajir South', countyName: 'Wajir' },
  { id: 'SC036', name: 'Wajir West', countyName: 'Wajir' },
  { id: 'SC037', name: 'Eldas', countyName: 'Wajir' },
  { id: 'SC038', name: 'Tarbaj', countyName: 'Wajir' },
  { id: 'SC039', name: 'Mandera West', countyName: 'Mandera' },
  { id: 'SC040', name: 'Mandera East', countyName: 'Mandera' },
  { id: 'SC041', name: 'Mandera South', countyName: 'Mandera' },
  { id: 'SC042', name: 'Mandera North', countyName: 'Mandera' },
  { id: 'SC043', name: 'Banissa', countyName: 'Mandera' },
  { id: 'SC044', name: 'Lafey', countyName: 'Mandera' },
  { id: 'SC045', name: 'Moyale', countyName: 'Marsabit' },
  { id: 'SC046', name: 'North Horr', countyName: 'Marsabit' },
  { id: 'SC047', name: 'Saku', countyName: 'Marsabit' },
  { id: 'SC048', name: 'Laisamis', countyName: 'Marsabit' },
  { id: 'SC049', name: 'Isiolo North', countyName: 'Isiolo' },
  { id: 'SC050', name: 'Isiolo South', countyName: 'Isiolo' },
  { id: 'SC051', name: 'Igembe South', countyName: 'Meru' },
  { id: 'SC052', name: 'Igembe Central', countyName: 'Meru' },
  { id: 'SC053', name: 'Igembe North', countyName: 'Meru' },
  { id: 'SC054', name: 'Tigania West', countyName: 'Meru' },
  { id: 'SC055', name: 'Tigania East', countyName: 'Meru' },
  { id: 'SC056', name: 'North Imenti', countyName: 'Meru' },
  { id: 'SC057', name: 'Buuri', countyName: 'Meru' },
  { id: 'SC058', name: 'Central Imenti', countyName: 'Meru' },
  { id: 'SC059', name: 'South Imenti', countyName: 'Meru' },
  { id: 'SC060', name: 'Maara', countyName: 'Tharaka-Nithi' },
  { id: 'SC061', name: 'Chuka/Igambang\'ombe', countyName: 'Tharaka-Nithi' },
  { id: 'SC062', name: 'Tharaka', countyName: 'Tharaka-Nithi' },
  { id: 'SC063', name: 'Manyatta', countyName: 'Embu' },
  { id: 'SC064', name: 'Runyenjes', countyName: 'Embu' },
  { id: 'SC065', name: 'Mbeere South', countyName: 'Embu' },
  { id: 'SC066', name: 'Mbeere North', countyName: 'Embu' },
  { id: 'SC067', name: 'Mwingi North', countyName: 'Kitui' },
  { id: 'SC068', name: 'Mwingi West', countyName: 'Kitui' },
  { id: 'SC069', name: 'Mwingi Central', countyName: 'Kitui' },
  { id: 'SC070', name: 'Kitui West', countyName: 'Kitui' },
  { id: 'SC071', name: 'Kitui Rural', countyName: 'Kitui' },
  { id: 'SC072', name: 'Kitui Central', countyName: 'Kitui' },
  { id: 'SC073', name: 'Kitui East', countyName: 'Kitui' },
  { id: 'SC074', name: 'Kitui South', countyName: 'Kitui' },
  { id: 'SC075', name: 'Mavoko', countyName: 'Machakos' },
  { id: 'SC076', name: 'Machakos Town', countyName: 'Machakos' },
  { id: 'SC077', name: 'Yatta', countyName: 'Machakos' },
  { id: 'SC078', name: 'Kangundo', countyName: 'Machakos' },
  { id: 'SC079', name: 'Matungulu', countyName: 'Machakos' },
  { id: 'SC080', name: 'Kathiani', countyName: 'Machakos' },
  { id: 'SC081', name: 'Mwala', countyName: 'Machakos' },
  { id: 'SC082', name: 'Masinga', countyName: 'Machakos' },
  { id: 'SC083', name: 'Wote', countyName: 'Makueni' },
  { id: 'SC084', name: 'Mbooni', countyName: 'Makueni' },
  { id: 'SC085', name: 'Kilome', countyName: 'Makueni' },
  { id: 'SC086', name: 'Kaiti', countyName: 'Makueni' },
  { id: 'SC087', name: 'Makueni', countyName: 'Makueni' },
  { id: 'SC088', name: 'Kibwezi West', countyName: 'Makueni' },
  { id: 'SC089', name: 'Kibwezi East', countyName: 'Makueni' },
  { id: 'SC090', name: 'Ol Kalou', countyName: 'Nyandarua' },
  { id: 'SC091', name: 'Kinangop', countyName: 'Nyandarua' },
  { id: 'SC092', name: 'Kipipiri', countyName: 'Nyandarua' },
  { id: 'SC093', name: 'Ndaragwa', countyName: 'Nyandarua' },
  { id: 'SC094', name: 'Nyandarua Central', countyName: 'Nyandarua' },
  { id: 'SC095', name: 'Nyeri Town', countyName: 'Nyeri' },
  { id: 'SC096', name: 'Mathira East', countyName: 'Nyeri' },
  { id: 'SC097', name: 'Mathira West', countyName: 'Nyeri' },
  { id: 'SC098', name: 'Kieni East', countyName: 'Nyeri' },
  { id: 'SC099', name: 'Kieni West', countyName: 'Nyeri' },
  { id: 'SC100', name: 'Mukurweini', countyName: 'Nyeri' },
  { id: 'SC101', name: 'Othaya', countyName: 'Nyeri' },
  { id: 'SC102', name: 'Gichugu', countyName: 'Kirinyaga' },
  { id: 'SC103', name: 'Ndia', countyName: 'Kirinyaga' },
  { id: 'SC104', name: 'Kirinyaga Central', countyName: 'Kirinyaga' },
  { id: 'SC105', name: 'Mwea', countyName: 'Kirinyaga' },
  { id: 'SC106', name: 'Gatanga', countyName: 'Murang\'a' },
  { id: 'SC107', name: 'Kiharu', countyName: 'Murang\'a' },
  { id: 'SC108', name: 'Kigumo', countyName: 'Murang\'a' },
  { id: 'SC109', name: 'Maragwa', countyName: 'Murang\'a' },
  { id: 'SC110', name: 'Kandara', countyName: 'Murang\'a' },
  { id: 'SC111', name: 'Kangema', countyName: 'Murang\'a' },
  { id: 'SC112', name: 'Mathioya', countyName: 'Murang\'a' },
  { id: 'SC113', name: 'Lari', countyName: 'Kiambu' },
  { id: 'SC114', name: 'Gatundu South', countyName: 'Kiambu' },
  { id: 'SC115', name: 'Gatundu North', countyName: 'Kiambu' },
  { id: 'SC116', name: 'Juja', countyName: 'Kiambu' },
  { id: 'SC117', name: 'Thika Town', countyName: 'Kiambu' },
  { id: 'SC118', name: 'Ruiru', countyName: 'Kiambu' },
  { id: 'SC119', name: 'Githunguri', countyName: 'Kiambu' },
  { id: 'SC120', name: 'Kiambu', countyName: 'Kiambu' },
  { id: 'SC121', name: 'Kiambaa', countyName: 'Kiambu' },
  { id: 'SC122', name: 'Kabete', countyName: 'Kiambu' },
  { id: 'SC123', name: 'Kikuyu', countyName: 'Kiambu' },
  { id: 'SC124', name: 'Limuru', countyName: 'Kiambu' },
  { id: 'SC125', name: 'Turkana North', countyName: 'Turkana' },
  { id: 'SC126', name: 'Turkana West', countyName: 'Turkana' },
  { id: 'SC127', name: 'Turkana Central', countyName: 'Turkana' },
  { id: 'SC128', name: 'Loima', countyName: 'Turkana' },
  { id: 'SC129', name: 'Turkana South', countyName: 'Turkana' },
  { id: 'SC130', name: 'Turkana East', countyName: 'Turkana' },
  { id: 'SC131', name: 'Kapenguria', countyName: 'West Pokot' },
  { id: 'SC132', name: 'Sigor', countyName: 'West Pokot' },
  { id: 'SC133', name: 'Kacheliba', countyName: 'West Pokot' },
  { id: 'SC134', name: 'Pokot South', countyName: 'West Pokot' },
  { id: 'SC135', name: 'Samburu West', countyName: 'Samburu' },
  { id: 'SC136', name: 'Samburu North', countyName: 'Samburu' },
  { id: 'SC137', name: 'Samburu East', countyName: 'Samburu' },
  { id: 'SC138', name: 'Kwanza', countyName: 'Trans Nzoia' },
  { id: 'SC139', name: 'Endebess', countyName: 'Trans Nzoia' },
  { id: 'SC140', name: 'Saboti', countyName: 'Trans Nzoia' },
  { id: 'SC141', name: 'Kiminini', countyName: 'Trans Nzoia' },
  { id: 'SC142', name: 'Cherangany', countyName: 'Trans Nzoia' },
  { id: 'SC143', name: 'Eldoret East', countyName: 'Uasin Gishu' },
  { id: 'SC144', name: 'Eldoret West', countyName: 'Uasin Gishu' },
  { id: 'SC145', name: 'Soy', countyName: 'Uasin Gishu' },
  { id: 'SC146', name: 'Turbo', countyName: 'Uasin Gishu' },
  { id: 'SC147', name: 'Moiben', countyName: 'Uasin Gishu' },
  { id: 'SC148', name: 'Ainabkoi', countyName: 'Uasin Gishu' },
  { id: 'SC149', name: 'Kapseret', countyName: 'Uasin Gishu' },
  { id: 'SC150', name: 'Kesses', countyName: 'Uasin Gishu' },
  { id: 'SC151', name: 'Marakwet East', countyName: 'Elgeyo-Marakwet' },
  { id: 'SC152', name: 'Marakwet West', countyName: 'Elgeyo-Marakwet' },
  { id: 'SC153', name: 'Keiyo North', countyName: 'Elgeyo-Marakwet' },
  { id: 'SC154', name: 'Keiyo South', countyName: 'Elgeyo-Marakwet' },
  { id: 'SC155', name: 'Tinderet', countyName: 'Nandi' },
  { id: 'SC156', name: 'Aldai', countyName: 'Nandi' },
  { id: 'SC157', name: 'Nandi Hills', countyName: 'Nandi' },
  { id: 'SC158', name: 'Chesumei', countyName: 'Nandi' },
  { id: 'SC159', name: 'Emgwen North', countyName: 'Nandi' },
  { id: 'SC160', name: 'Mosop', countyName: 'Nandi' },
  { id: 'SC161', name: 'Kabartonjo', countyName: 'Baringo' },
  { id: 'SC162', name: 'Baringo North', countyName: 'Baringo' },
  { id: 'SC163', name: 'Baringo Central', countyName: 'Baringo' },
  { id: 'SC164', name: 'Baringo South', countyName: 'Baringo' },
  { id: 'SC165', name: 'Tiaty', countyName: 'Baringo' },
  { id: 'SC166', name: 'Mogotio', countyName: 'Baringo' },
  { id: 'SC167', name: 'Eldama Ravine', countyName: 'Baringo' },
  { id: 'SC168', name: 'Laikipia West', countyName: 'Laikipia' },
  { id: 'SC169', name: 'Laikipia East', countyName: 'Laikipia' },
  { id: 'SC170', name: 'Laikipia North', countyName: 'Laikipia' },
  { id: 'SC171', name: 'Molo', countyName: 'Nakuru' },
  { id: 'SC172', name: 'Njoro', countyName: 'Nakuru' },
  { id: 'SC173', name: 'Naivasha', countyName: 'Nakuru' },
  { id: 'SC174', name: 'Gilgil', countyName: 'Nakuru' },
  { id: 'SC175', name: 'Kuresoi South', countyName: 'Nakuru' },
  { id: 'SC176', name: 'Kuresoi North', countyName: 'Nakuru' },
  { id: 'SC177', name: 'Subukia', countyName: 'Nakuru' },
  { id: 'SC178', name: 'Rongai', countyName: 'Nakuru' },
  { id: 'SC179', name: 'Bahati', countyName: 'Nakuru' },
  { id: 'SC180', name: 'Nakuru Town West', countyName: 'Nakuru' },
  { id: 'SC181', name: 'Nakuru Town East', countyName: 'Nakuru' },
  { id: 'SC182', name: 'Narok North', countyName: 'Narok' },
  { id: 'SC183', name: 'Narok South', countyName: 'Narok' },
  { id: 'SC184', name: 'Narok East', countyName: 'Narok' },
  { id: 'SC185', name: 'Narok West', countyName: 'Narok' },
  { id: 'SC186', name: 'Emurua Dikirr', countyName: 'Narok' },
  { id: 'SC187', name: 'Kilgoris', countyName: 'Narok' },
  { id: 'SC188', name: 'Kajiado North', countyName: 'Kajiado' },
  { id: 'SC189', name: 'Kajiado Central', countyName: 'Kajiado' },
  { id: 'SC190', name: 'Kajiado East', countyName: 'Kajiado' },
  { id: 'SC191', name: 'Kajiado West', countyName: 'Kajiado' },
  { id: 'SC192', name: 'Kajiado South', countyName: 'Kajiado' },
  { id: 'SC193', name: 'Ainamoi', countyName: 'Kericho' },
  { id: 'SC194', name: 'Belgut', countyName: 'Kericho' },
  { id: 'SC195', name: 'Kipkelion East', countyName: 'Kericho' },
  { id: 'SC196', name: 'Kipkelion West', countyName: 'Kericho' },
  { id: 'SC197', name: 'Sigowet/Soin', countyName: 'Kericho' },
  { id: 'SC198', name: 'Bureti', countyName: 'Kericho' },
  { id: 'SC199', name: 'Bomet Central', countyName: 'Bomet' },
  { id: 'SC200', name: 'Bomet East', countyName: 'Bomet' },
  { id: 'SC201', name: 'Chepalungu', countyName: 'Bomet' },
  { id: 'SC202', name: 'Sotik', countyName: 'Bomet' },
  { id: 'SC203', name: 'Konoin', countyName: 'Bomet' },
  { id: 'SC204', name: 'Lugari', countyName: 'Kakamega' },
  { id: 'SC205', name: 'Likuyani', countyName: 'Kakamega' },
  { id: 'SC206', name: 'Malava', countyName: 'Kakamega' },
  { id: 'SC207', name: 'Lurambi', countyName: 'Kakamega' },
  { id: 'SC208', name: 'Navakholo', countyName: 'Kakamega' },
  { id: 'SC209', name: 'Mumias West', countyName: 'Kakamega' },
  { id: 'SC210', name: 'Mumias East', countyName: 'Kakamega' },
  { id: 'SC211', name: 'Matungu', countyName: 'Kakamega' },
  { id: 'SC212', name: 'Butere', countyName: 'Kakamega' },
  { id: 'SC213', name: 'Khwisero', countyName: 'Kakamega' },
  { id: 'SC214', name: 'Shinyalu', countyName: 'Kakamega' },
  { id: 'SC215', name: 'Ikolomani', countyName: 'Kakamega' },
  { id: 'SC216', name: 'Hamisi', countyName: 'Vihiga' },
  { id: 'SC217', name: 'Luanda', countyName: 'Vihiga' },
  { id: 'SC218', name: 'Emuhaya', countyName: 'Vihiga' },
  { id: 'SC219', name: 'Sabatia', countyName: 'Vihiga' },
  { id: 'SC220', name: 'Vihiga', countyName: 'Vihiga' },
  { id: 'SC221', name: 'Webuye East', countyName: 'Bungoma' },
  { id: 'SC222', name: 'Webuye West', countyName: 'Bungoma' },
  { id: 'SC223', name: 'Kimilili', countyName: 'Bungoma' },
  { id: 'SC224', name: 'Tongaren', countyName: 'Bungoma' },
  { id: 'SC225', name: 'Sirisia', countyName: 'Bungoma' },
  { id: 'SC226', name: 'Bumula', countyName: 'Bungoma' },
  { id: 'SC227', name: 'Kanduyi', countyName: 'Bungoma' },
  { id: 'SC228', name: 'Kabuchai', countyName: 'Bungoma' },
  { id: 'SC229', name: 'Mt. Elgon', countyName: 'Bungoma' },
  { id: 'SC230', name: 'Teso North', countyName: 'Busia' },
  { id: 'SC231', name: 'Teso South', countyName: 'Busia' },
  { id: 'SC232', name: 'Nambale', countyName: 'Busia' },
  { id: 'SC233', name: 'Matayos', countyName: 'Busia' },
  { id: 'SC234', name: 'Butula', countyName: 'Busia' },
  { id: 'SC235', name: 'Funyula', countyName: 'Busia' },
  { id: 'SC236', name: 'Budalangi', countyName: 'Busia' },
  { id: 'SC237', name: 'Ugenya', countyName: 'Siaya' },
  { id: 'SC238', name: 'Ugunja', countyName: 'Siaya' },
  { id: 'SC239', name: 'Alego Usonga', countyName: 'Siaya' },
  { id: 'SC240', name: 'Gem', countyName: 'Siaya' },
  { id: 'SC241', name: 'Bondo', countyName: 'Siaya' },
  { id: 'SC242', name: 'Rarieda', countyName: 'Siaya' },
  { id: 'SC243', name: 'Kisumu East', countyName: 'Kisumu' },
  { id: 'SC244', name: 'Kisumu West', countyName: 'Kisumu' },
  { id: 'SC245', name: 'Kisumu Central', countyName: 'Kisumu' },
  { id: 'SC246', name: 'Seme', countyName: 'Kisumu' },
  { id: 'SC247', name: 'Nyando', countyName: 'Kisumu' },
  { id: 'SC248', name: 'Muhoroni', countyName: 'Kisumu' },
  { id: 'SC249', name: 'Nyakach', countyName: 'Kisumu' },
  { id: 'SC250', name: 'Mbita', countyName: 'Homa Bay' },
  { id: 'SC251', name: 'Suba North', countyName: 'Homa Bay' },
  { id: 'SC252', name: 'Suba South', countyName: 'Homa Bay' },
  { id: 'SC253', name: 'Rangwe', countyName: 'Homa Bay' },
  { id: 'SC254', name: 'Homa Bay Town', countyName: 'Homa Bay' },
  { id: 'SC255', name: 'Ndhiwa', countyName: 'Homa Bay' },
  { id: 'SC256', name: 'Kasipul', countyName: 'Homa Bay' },
  { id: 'SC257', name: 'Kabondo Kasipul', countyName: 'Homa Bay' },
  { id: 'SC258', name: 'Karachuonyo', countyName: 'Homa Bay' },
  { id: 'SC260', name: 'Kuria West', countyName: 'Migori' },
  { id: 'SC261', name: 'Kuria East', countyName: 'Migori' },
  { id: 'SC262', name: 'Rongo', countyName: 'Migori' },
  { id: 'SC263', name: 'Awendo', countyName: 'Migori' },
  { id: 'SC264', name: 'Suna East', countyName: 'Migori' },
  { id: 'SC265', name: 'Suna West', countyName: 'Migori' },
  { id: 'SC266', name: 'Uriri', countyName: 'Migori' },
  { id: 'SC267', name: 'Nyatike', countyName: 'Migori' },
  { id: 'SC268', name: 'Gucha', countyName: 'Kisii' },
  { id: 'SC269', name: 'Gucha South', countyName: 'Kisii' },
  { id: 'SC270', name: 'Kenyenya', countyName: 'Kisii' },
  { id: 'SC271', name: 'Bobasi', countyName: 'Kisii' },
  { id: 'SC272', name: 'Bomachoge Borabu', countyName: 'Kisii' },
  { id: 'SC273', name: 'Bomachoge Chache', countyName: 'Kisii' },
  { id: 'SC274', name: 'Nyaribari Masaba', countyName: 'Kisii' },
  { id: 'SC275', name: 'Nyaribari Chache', countyName: 'Kisii' },
  { id: 'SC276', name: 'Kitutu Chache North', countyName: 'Kisii' },
  { id: 'SC277', name: 'Kitutu Chache South', countyName: 'Kisii' },
  { id: 'SC278', name: 'North Mugirango', countyName: 'Nyamira' },
  { id: 'SC279', name: 'West Mugirango', countyName: 'Nyamira' },
  { id: 'SC280', name: 'Kitutu Masaba', countyName: 'Nyamira' },
  { id: 'SC281', name: 'Borabu', countyName: 'Nyamira' },
  { id: 'SC282', name: 'Westlands', countyName: 'Nairobi' },
  { id: 'SC283', name: 'Dagoretti North', countyName: 'Nairobi' },
  { id: 'SC284', name: 'Dagoretti South', countyName: 'Nairobi' },
  { id: 'SC285', name: 'Langata', countyName: 'Nairobi' },
  { id: 'SC286', name: 'Kibra', countyName: 'Nairobi' },
  { id: 'SC287', name: 'Roysambu', countyName: 'Nairobi' },
  { id: 'SC288', name: 'Kasarani', countyName: 'Nairobi' },
  { id: 'SC289', name: 'Ruaraka', countyName: 'Nairobi' },
  { id: 'SC290', name: 'Embakasi South', countyName: 'Nairobi' },
  { id: 'SC291', name: 'Embakasi North', countyName: 'Nairobi' },
  { id: 'SC292', name: 'Embakasi Central', countyName: 'Nairobi' },
  { id: 'SC293', name: 'Embakasi East', countyName: 'Nairobi' },
  { id: 'SC294', name: 'Embakasi West', countyName: 'Nairobi' },
  { id: 'SC295', name: 'Makadara', countyName: 'Nairobi' },
  { id: 'SC296', name: 'Kamukunji', countyName: 'Nairobi' },
  { id: 'SC297', name: 'Starehe', countyName: 'Nairobi' },
  { id: 'SC298', name: 'Mathare', countyName: 'Nairobi' }
];

// Sample facilities
export const facilities: Facility[] = [
    { id: "CHU0001", name: "Nyamamithi Community Health Unit", subCountyName: "Rongai" },
    { id: "CHU0002", name: "Lenginet Community Health Unit", subCountyName: "Rongai" },
    { id: "CHU0003", name: "Kawalathe Community Health Unit", subCountyName: "Loima" },
    { id: "CHU0004", name: "Lopur Community Health Unit", subCountyName: "Turkana West" },
    { id: "CHU0005", name: "Kaiboi Community Health Unit", subCountyName: "Mosop" },
    { id: "CHU0006", name: "Rukuine Community Health Unit", subCountyName: "Kesses" },
    { id: "CHU0007", name: "Chepsire Community Health Unit", subCountyName: "Tinderet" },
    { id: "CHU0008", name: "Gatina Community Health Unit", subCountyName: "Kiambu" },
    { id: "CHU0009", name: "Samoo Community Health Unit", subCountyName: "Chesumei" },
    { id: "CHU0010", name: "Kathieno A Community Health Unit", subCountyName: "Ugenya" },
    { id: "CHU0011", name: "Oldebes Community Health Unit", subCountyName: "Mogotio" },
    { id: "CHU0012", name: "Mwihoko 1 Community Health Unit", subCountyName: "Githunguri" },
    { id: "CHU0013", name: "Nyambugo Community Health Unit", subCountyName: "Chepalungu" },
    { id: "CHU0014", name: "Keresa Community Health Unit", subCountyName: "Ganze" },
    { id: "CHU0015", name: "Goshi Community Health Unit", subCountyName: "Ganze" },
    { id: "CHU0016", name: "Kiratina Community Health Unit", subCountyName: "Githunguri" },
    { id: "CHU0017", name: "Naroo Community Health Unit", subCountyName: "Turkana West" },
    { id: "CHU0018", name: "Chalani Community Health Unit", subCountyName: "Kaloleni" },
    { id: "CHU0019", name: "Ikoli Community Health Unit", subCountyName: "Malava" },
    { id: "CHU0020", name: "Loroo Community Health Unit", subCountyName: "Loima" },
    { id: "CHU0021", name: "Wagwe North Community Health Unit", subCountyName: "Karachuonyo" },
    { id: "CHU0022", name: "Wagwe South Community Health Unit", subCountyName: "Karachuonyo" },
    { id: "CHU0023", name: "Ombek Community Health Unit", subCountyName: "Karachuonyo" },
    { id: "CHU0024", name: "Rangwe Community Health Unit", subCountyName: "Rangwe" }
  ];

// Real Subcounties (focusing on Coast region for demonstration)
const SUBCOUNTIES = [
  // Kilifi County Subcounties
  { id: 'SC001', name: 'Kilifi North', countyId: 'C001' },
  { id: 'SC002', name: 'Kilifi South', countyId: 'C001' },
  { id: 'SC003', name: 'Ganze', countyId: 'C001' },
  { id: 'SC004', name: 'Malindi', countyId: 'C001' },
  { id: 'SC005', name: 'Magarini', countyId: 'C001' },
  { id: 'SC006', name: 'Kaloleni', countyId: 'C001' },
  { id: 'SC007', name: 'Rabai', countyId: 'C001' },

  // Mombasa County Subcounties
  { id: 'SC008', name: 'Mvita', countyId: 'C002' },
  { id: 'SC009', name: 'Nyali', countyId: 'C002' },
  { id: 'SC010', name: 'Kisauni', countyId: 'C002' },
  { id: 'SC011', name: 'Likoni', countyId: 'C002' },
  { id: 'SC012', name: 'Changamwe', countyId: 'C002' },
  { id: 'SC013', name: 'Jomvu', countyId: 'C002' },

  // Kwale County Subcounties
  { id: 'SC014', name: 'Msambweni', countyId: 'C003' },
  { id: 'SC015', name: 'Lunga Lunga', countyId: 'C003' },
  { id: 'SC016', name: 'Kinango', countyId: 'C003' },
  { id: 'SC017', name: 'Matuga', countyId: 'C003' },
];

// Real Community Health Units (CHUs)
const CHUS = [
  // Kilifi North Subcounty CHUs
  { id: 'CHU001', name: 'Mtwapa Health Centre', subcountyId: 'SC001' },
  { id: 'CHU002', name: 'Tezo Health Centre', subcountyId: 'SC001' },
  { id: 'CHU003', name: 'Kibaoni Health Centre', subcountyId: 'SC001' },

  // Ganze Subcounty CHUs
  { id: 'CHU004', name: 'Ganze Health Centre', subcountyId: 'SC003' },
  { id: 'CHU005', name: 'Bamba Health Centre', subcountyId: 'SC003' },
  { id: 'CHU006', name: 'Vitengeni Dispensary', subcountyId: 'SC003' },

  // Malindi Subcounty CHUs
  { id: 'CHU007', name: 'Malindi District Hospital', subcountyId: 'SC004' },
  { id: 'CHU008', name: 'Ngala Health Centre', subcountyId: 'SC004' },
  { id: 'CHU009', name: 'Kakoneni Health Centre', subcountyId: 'SC004' },

  // Mvita Subcounty CHUs
  { id: 'CHU010', name: 'Coast General Hospital', subcountyId: 'SC008' },
  { id: 'CHU011', name: 'Tudor Health Centre', subcountyId: 'SC008' },

  // Nyali Subcounty CHUs
  { id: 'CHU012', name: 'Kongowea Health Centre', subcountyId: 'SC009' },
  { id: 'CHU013', name: 'Ziwa la Ng\'ombe Health Centre', subcountyId: 'SC009' },

  // Msambweni Subcounty CHUs
  { id: 'CHU014', name: 'Msambweni County Hospital', subcountyId: 'SC014' },
  { id: 'CHU015', name: 'Kinondo Health Centre', subcountyId: 'SC014' },
];

// Create the full location hierarchy
export const locations: Location[] = [
  // National level
  { id: KENYA_ID, name: 'Kenya', type: 'NATIONAL', parentId: null },
  
  // Counties
  ...counties.map((county: County) => ({
    id: county.id,
    name: county.name,
    type: 'COUNTY' as const,
    parentId: KENYA_ID,
  })),
  
  // Subcounties
  ...SUBCOUNTIES.map(subcounty => ({
    id: subcounty.id,
    name: subcounty.name,
    type: 'SUBCOUNTY' as const,
    parentId: subcounty.countyId,
  })),
  
  // CHUs
  ...CHUS.map(chu => ({
    id: chu.id,
    name: chu.name,
    type: 'CHU' as const,
    parentId: chu.subcountyId,
  })),
];

// Helper functions to navigate the hierarchy
export const getLocationById = (id: string): Location | undefined => {
  return locations.find(loc => loc.id === id);
};

export const getLocationsByCounty = (county: string): Location[] => {
  return locations.filter(loc => loc.parentId === counties.find(c => c.name === county)?.id);
};

export const getChildLocations = (parentId: string): Location[] => {
  return locations.filter(loc => loc.parentId === parentId);
};

export const getLocationHierarchy = (locationId: string): Location[] => {
  const hierarchy: Location[] = [];
  let currentLocation = getLocationById(locationId);
  
  while (currentLocation) {
    hierarchy.unshift(currentLocation);
    if (currentLocation.parentId) {
      currentLocation = getLocationById(currentLocation.parentId);
    } else {
      break;
    }
  }
  
  return hierarchy;
};
